import styled from "styled-components";

const S = {
    PageWrapper: styled.div`
        background: #f8fafc;
        min-height: 100vh;
        padding-bottom: 80px;
    `,
    HeroSection: styled.section`
        background: linear-gradient(135deg, #00A9C4 0%, #00798c 100%);
        padding: 80px 20px;
        text-align: center;
        color: white;

        .hero-content {
            max-width: 800px;
            margin: 0 auto;

            h1 {
                font-size: 3.5em;
                font-weight: 800;
                margin: 0 0 20px 0;
                letter-spacing: -1px;

                @media (max-width: 768px) {
                    font-size: 2.5em;
                }
            }
        }
    `,
    Breadcrumb: styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 1.1em;
        opacity: 0.9;
        
        a, span {
            color: white;
            text-decoration: none;
            font-weight: 500;
            transition: opacity 0.2s ease;
            
            &:hover {
                opacity: 0.7;
            }
        }
        
        .separator {
            font-size: 0.9em;
            opacity: 0.6;
        }
    `,
    ContentWrapper: styled.div`
        max-width: 1200px;
        margin: -40px auto 0;
        padding: 0 20px;
        display: flex;
        flex-direction: column;
        gap: 40px;
        position: relative;
        z-index: 10;
        
        .profile-card {
            background: #ffffff;
            border-radius: 24px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0,0,0,0.04);
            display: flex;
            flex-direction: row;
            overflow: hidden;
            
            @media (max-width: 900px) {
                flex-direction: column;
            }

            .profile-sidebar {
                width: 350px;
                background: linear-gradient(to bottom, #ffffff, #f0fbfc);
                padding: 40px 30px;
                display: flex;
                flex-direction: column;
                align-items: center;
                text-align: center;
                border-right: 1px solid rgba(0,0,0,0.04);
                
                @media (max-width: 900px) {
                    width: 100%;
                    border-right: none;
                    border-bottom: 1px solid rgba(0,0,0,0.04);
                }

                .avatar-wrapper {
                    width: 200px;
                    height: 200px;
                    border-radius: 50%;
                    overflow: hidden;
                    margin-bottom: 25px;
                    border: 6px solid #e0f2fe;
                    box-shadow: 0 10px 25px rgba(0,169,196,0.15);
                    
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                        object-position: top;
                    }
                }

                h2 {
                    font-size: 1.8em;
                    color: #0369a1;
                    margin: 0 0 15px 0;
                    font-weight: 800;
                }

                .tags {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                    width: 100%;
                    margin-bottom: 25px;

                    .badge {
                        padding: 8px 16px;
                        border-radius: 20px;
                        font-size: 0.9em;
                        font-weight: 600;

                        &.primary {
                            background: #e0f2fe;
                            color: #0ea5e9;
                        }
                        
                        &.secondary {
                            background: #f1f5f9;
                            color: #475569;
                        }
                    }
                }

                .short-desc {
                    p {
                        color: #64748b;
                        font-size: 0.95em;
                        line-height: 1.6;
                        margin: 0 0 10px 0;
                    }
                }
            }

            .profile-body {
                flex: 1;
                padding: 50px;
                display: flex;
                flex-direction: column;
                justify-content: center;

                @media (max-width: 900px) {
                    padding: 30px;
                }
                
                .ozgecmis {
                    p {
                        font-size: 1.1em;
                        color: #334155;
                        line-height: 1.8;
                        margin-bottom: 20px;
                        
                        &:last-child {
                            margin-bottom: 0;
                        }
                    }
                }
            }
        }

        .cv-card {
            background: #ffffff;
            border-radius: 24px;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
            border: 1px solid rgba(0,0,0,0.04);
            padding: 40px;
            overflow: hidden;

            @media (max-width: 768px) {
                padding: 20px;
            }

            .cv-header {
                font-size: 1.8em;
                color: #1e293b;
                margin: 0 0 30px 0;
                padding-bottom: 20px;
                border-bottom: 2px solid #f1f5f9;
                font-weight: 700;
            }

            .cv-body {
                width: 100%;
                overflow-x: auto;
                
                /* Resetting some bad inline styles from icv for better readability within the card */
                h2, p, span, li, a {
                    line-height: 1.6 !important;
                    font-family: inherit !important;
                }
                
                li {
                    margin-bottom: 15px;
                }

                /* Restoring specific classes used in the CV HTML without font overrides */
                .s1 { font-weight: bold; text-decoration: underline; }
                .h2, h2 { font-weight: bold; font-size: 1.1em; margin-bottom: 10px; }
                .s3 { font-style: italic; }
                .s4 { font-weight: bold; }
                .s8 { font-size: 0.8em; vertical-align: super; }
                .s9 { font-style: italic; font-size: 0.8em; vertical-align: super; }
                .s10, .s14 { font-weight: bold; }
                .s12, .s18, .s21 { font-style: italic; }
                .s27 { text-decoration: underline; }

                /* Restoring list counters */
                ol { list-style: none; padding-left: 0; }
                
                #l1 { counter-reset: c1 1; }
                #l1>li>*:first-child:before { 
                    counter-increment: c1; 
                    content: counter(c1, upper-latin)". "; 
                    font-weight: bold; 
                    margin-right: 5px; 
                }
                
                #l2 { counter-reset: d1 1; }
                #l2>li>*:first-child:before { 
                    counter-increment: d1; 
                    content: counter(d1, decimal)". "; 
                    font-weight: bold; 
                    margin-right: 5px; 
                }

                #l3 { counter-reset: e1 1; }
                #l3>li>*:first-child:before { 
                    counter-increment: e1; 
                    content: counter(e1, decimal)". "; 
                    margin-right: 5px; 
                }

                #l4>li>*:first-child:before, 
                #l5>li>*:first-child:before, 
                #l6>li>*:first-child:before, 
                #l7>li>*:first-child:before, 
                #l8>li>*:first-child:before, 
                #l9>li>*:first-child:before, 
                #l10>li>*:first-child:before, 
                #l11>li>*:first-child:before { 
                    content: "• "; 
                    margin-right: 5px;
                }
            }
        }
    `
};

export default S;